/*
Global file for setting React routes.
*/

import React, { Suspense, lazy } from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import { observer } from 'mobx-react';

import {
    PATH_ERROR,
    PATH_SUCCESS
} from '~/common/utils/consts.js';
import LoadingSpinner from '~/common/components/LoadingSpinner';

// Import the page views
const ViewWrapper = lazy(() => import('~/views/ViewWrapper.js'));
const ErrorView = lazy(() => import('~/views/ErrorView'));

@withRouter
@observer
export default class Routes extends React.Component {
    componentDidUpdate() {
        window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    }

    render() {
        return (
            <Suspense fallback={<LoadingSpinner />}>
                <Switch>
                    {/* error page */}
                    <Route
                        path={PATH_ERROR}
                        render={() => <ErrorView />}
                    />
                    {/* main page */}
                    <Route
                        path={'/'}
                        render={() => <ViewWrapper />}
                    />
                </Switch>
            </Suspense>
        );
    }
}
